/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Toaster} from "react-hot-toast";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import Pagination from "../../../Components/Common/Pagination";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import * as XLSX from "xlsx";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";
import PrintFilterBonusForm from "../../../Components/Statistics/CreditBalances/PrintFilterBonusForm";

function ActivationBonusStudentsPage() {
  
  const [modal, setModal] = useStateCallback(false);
  const [activationBonusList, setActivationBonusList] = useState([]);
  const [printableList, setPrintableList] = useState([]);
  const {schoolList} = useContext(SchoolContext); 
  const [school, setSchool] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [first, setFirst] = useState("");

  const getStudentList = async () => {
    setActivationBonusList([]);
    setLoading(true);
    const server_response = await ajaxStudent.listAllActivationBonusStudents(page);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setActivationBonusList(server_response.details.data || []);
    } else {
      setActivationBonusList([]);
    }
  };

  const searchStudentList = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllActivationBonusStudents(page, school, startDate, endDate);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setActivationBonusList(server_response.details.data || []);
    } else {
      setActivationBonusList([]);
    }
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };
  
  useEffect(() => {
    if (startDate || endDate || school) {
      searchStudentList();
    }else {
      getStudentList(page);
    }
  }, [page]);


  const setStudents = (e) => {
    e.preventDefault();
    setStartDate("");
    setEndDate("")
    setSchool("")
    setPage(1);
    getStudentList(1);
  };

  const refreshData = () => {
    getStudentList(1);
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterBonusForm
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Names": item.student_name,
          "Username": item.username,
          "School": item.school,
          "Student Class": item.group,
          "Default PIN": item.default_pin
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Activation Bonus Students");
      
        XLSX.writeFile(workbook, "activation_bonus_student_list.xlsx");
  };

  
  return (

    <AppContainer title="Activation Bonus Students">
        <Toaster position="top-center" reverseOrder={false} />
        {modal}
        <div className="row">
            <div className="col-lg-12">
                <div className="card custom-card">
                    <div className="card-body map-card">
                        <div class="heading-layout1 mg-b-25">
                            <TableHeader
                                title="Activation Bonus Students"
                                subtitle="List of all the students with only activation bonuses in their user wallets"
                            />
                            <div class="dropdown">
                                <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false">...</Link>

                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={handleModal} ><i class="fas fa-file-export"></i>Export</Link>
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link> 
                                </div>
                            </div>
                        </div>

                        <form className="mg-t-20" onSubmit={searchStudentList}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          
            <div className="col-lg-5">
            <Select
                onChange={(e) => setSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                        school === "" ? null
                          : Array.isArray(schoolList) &&
                            schoolList.find((value) => value.school_id === school)
                      }
                
            />
            </div>
            <div className="col-lg-7">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={setStudents}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>

                        <div className="border-top mt-3"></div>
                        <div className="table-responsive">
                            {loading || loading2 ? (
                                <Loader />
                            ) : (
                                <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Names</th>
                                            <th>Username</th>
                                            <th>School</th>
                                            <th>Class</th>
                                            <th>Default PIN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activationBonusList.length > 0 ? (
                                            activationBonusList.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{width:"5px"}}>{index + first + 1}</td>
                                                <td>
                                                    <Link to={`/students/profile/${item.student_id}/${item.user_id}`}>
                                                    {item.student_name}
                                                    </Link>
                                                </td>
                                                <td className="text-dark">{item.username}</td>

                                                <td className="text-dark">{item.school}</td>
                                                <td className="text-dark">{item.group}</td>

                                                <td className="text-dark"><span className="badge badge-danger">{item.default_pin}</span></td>

                                                
                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="6" style={{ textAlign: "center" }}>
                                                    No students found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                    
                    </div>
                </div>
            </div>
        </div>
    </AppContainer>
  );
}

export default ActivationBonusStudentsPage;